module.exports = __webpack_public_path__ + "img/label_city@2x.86a7445b.png";